<template>
    <div>
        <Modal v-model="modal" :title="!trustAdvisorWarningForm.id ? this.$t('TrustAdvisor.addTrustAdvisorAlert'):this.$t('TrustAdvisor.updateTrustAdvisorAlert')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :closable="false">
            <Form ref="trustAdvisorWarningForm" :model="trustAdvisorWarningForm" :label-width="110" :rules="ruleValidate">
                <!-- 微信警告 -->
                <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
                <!-- 规则名称 -->
                <FormItem :label="this.$t('alarms.common.alertRuleName')" prop="ruleName" v-if="isEditRuleName">
                    <Row>
                        <Col span="11">
                            <Input type="text" v-model="trustAdvisorWarningForm.ruleName" placeholder="Enter something..."
                           style="width:300px;" :disabled="isEdit"></Input>
                        </Col>
                     </Row>
                </FormItem>

                <!-- 规则名称 -->
                <FormItem :label="this.$t('alarms.common.alertRuleName')" v-if="showRuleName">
                    <Row>
                        <Col span="24">
                            <div>{{this.trustAdvisorWarningForm.ruleName}}</div>
                        </Col>
                    </Row>
                </FormItem>


                <!-- 账户  @on-change="changeAccount(trustAdvisorWarningForm.account)"-->
                <FormItem :label="this.$t('alarms.common.account')" prop="account">
                    <Select v-model="trustAdvisorWarningForm.account" filterable :placeholder="this.$t('alarms.common.pleaseSelect')"  :transfer="true" style="width:300px;" label-in-value>
                        <Option @click.native="changeAccount(item)" :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 存储区域 -->
                <FormItem :label="this.$t('alarms.common.region')" prop="backupRegion">
                    <Select @on-change="changebackupRegion(trustAdvisorWarningForm.backupRegion)" filterable :placeholder="this.$t('alarms.common.pleaseSelect')" v-model="trustAdvisorWarningForm.backupRegion" multiple :max-tag-count="1" :transfer="true" style="width:300px;">
                        <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                        <Option :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 顾问列表 -->
                <FormItem :label="this.$t('TrustAdvisor.consultant')" prop="trustedAdvisorItems">
                  <Select @on-change="changeTrustedAdvisorItems(trustAdvisorWarningForm.trustedAdvisorItems)" filterable :placeholder="this.$t('alarms.common.pleaseSelect')" v-model="trustAdvisorWarningForm.trustedAdvisorItems" multiple :max-tag-count="1" :transfer="true" style="width:300px;">
                    <Checkbox v-model="singleTrustedAdvisorItems" @on-change="selectTrustedAdvisorItems" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                    <Option :value="item.name" v-for="(item,index) in trustedAdvisorItemsList" :key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>

                <!-- 规则描述 -->
                <FormItem :label="this.$t('alarms.common.alertRuleDesc')">
                    <Row :gutter="4">
                        <!-- 监控指标 -->
                        <Col span="6">
                            <FormItem prop="monitorIndex">
                                <Select v-model="trustAdvisorWarningForm.monitorIndex" filterable :placeholder="this.$t('alarms.common.monitorIndex')" @on-change="changeMonitorIndex(trustAdvisorWarningForm.monitorIndex)">
                                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 周期 -->
                        <Col span="3">
                            <FormItem prop="cycle">
                                <Select v-model="trustAdvisorWarningForm.cycle" filterable :placeholder="this.$t('alarms.common.cycle')" @on-change="changeCycle(trustAdvisorWarningForm.cycle)">
                                    <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 连续周期 -->
                        <Col span="4">
                            <FormItem prop="continousCycle">
                                <Select v-model="trustAdvisorWarningForm.continousCycle" filterable :placeholder="this.$t('alarms.common.continuous')"
                                      @on-change="changeContinousCycle(trustAdvisorWarningForm.continousCycle)">
                                    <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 统计数值 -->
                        <Col span="4">
                            <FormItem prop="statisticsValue">
                                <Select v-model="trustAdvisorWarningForm.statisticsValue" filterable :placeholder="this.$t('alarms.common.statisticsValue')"
                                  @on-change="changeStatisticsValue(trustAdvisorWarningForm.statisticsValue)">
                                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>


                        <!-- 如果监控指标为TrustAdvisor时 不显示符号、阈值和单位 -->
                        <div v-if="this.isShowField!=1">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="trustAdvisorWarningForm.relationshipSign" filterable @on-change="changeRelationshipSign(trustAdvisorWarningForm.relationshipSign)" :placeholder="this.$t('alarms.common.sign')">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="trustAdvisorWarningForm.thresholdValue" :placeholder="this.$t('alarms.common.threshold')"
                                       type="number"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="trustAdvisorWarningForm.unit" disabled :placeholder="this.$t('alarms.common.unit')"></Input>
                                </FormItem>
                            </Col>
                        </div>
                        <div v-else-if="this.isShowField==2">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="trustAdvisorWarningForm.relationshipSign" filterable @on-change="changeRelationshipSign(trustAdvisorWarningForm.relationshipSign)" :placeholder="this.$t('alarms.common.sign')">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="trustAdvisorWarningForm.thresholdValue" :placeholder="this.$t('alarms.common.threshold')" type="number"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="trustAdvisorWarningForm.unit" disabled :placeholder="this.$t('alarms.common.unit')"></Input>
                                </FormItem>
                            </Col>
                        </div>
                    </Row>
                </FormItem>

                <!-- 联系方式 -->
                <FormItem :label="this.$t('alarms.billing.contactWay')" prop="contactType">
                    <RadioGroup v-model="trustAdvisorWarningForm.contactType" @on-change="changeContactType(trustAdvisorWarningForm.contactType)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                    </RadioGroup>
                </FormItem>

                <!-- 通知对象 -->
                <FormItem :label="this.$t('alarms.common.contact')" prop="notificationObject"  v-if="trustAdvisorWarningForm.contactType==0">
                    <Select v-model="trustAdvisorWarningForm.notificationObject" multiple filterable style="width:300px;" @on-change="changeNotificationObject" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 联系人组 -->
                <FormItem :label="this.$t('alarms.common.alertContactGroup')" prop="contactGroupIds" v-if="trustAdvisorWarningForm.contactType==1">
                    <Select v-model="trustAdvisorWarningForm.contactGroupId" multiple filterable style="width:300px;" @on-change="changeContactGroupId(trustAdvisorWarningForm.contactGroupIds)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 报警方式 -->
                <FormItem :label="this.$t('alarms.common.alarmType')" prop="noticeType">
                    <Select v-model="trustAdvisorWarningForm.noticeType" multiple filterable style="width:300px;" @on-change="selectnoticeType(trustAdvisorWarningForm.noticeType)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 企业微信机器人URL -->
                <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="trustAdvisorWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
                    <Select v-model="trustAdvisorWarningForm.enterpriseWechatRobotIds" multiple filterable style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 延迟告警 -->
                <FormItem :label="this.$t('alarms.common.delayAlarm')" prop="alarmDelay">
                    <Select v-model="trustAdvisorWarningForm.alarmDelay" filterable style="width:300px;" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

              <!-- 监控时段 -->
              <FormItem :label="this.$t('alarms.common.monitoringTime')" prop="monitorPeriod">
                <Select v-model="trustAdvisorWarningForm.monitorPeriod" filterable style="width:300px;" :placeholder="this.$t('alarms.common.pleaseSelect')">
                  <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>

                <!-- 邮箱模板 -->
                <div v-show="isShowEmail">
                    <FormItem :label="this.$t('alarms.common.emailTemplate')" prop="emailModal">
                        <Input v-model="trustAdvisorWarningForm.emailModal" type="textarea"
                         :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
                    </FormItem>
                </div>

                <!-- 企业微信模板 -->
                <div v-show="isShowWeChat">
                    <FormItem :label="this.$t('alarms.common.weChatTemplate')" prop="wechatModal">
                        <Input v-model="trustAdvisorWarningForm.wechatModal" type="textarea"
                         :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
                    </FormItem>
                </div>
            </Form>
            <div slot="footer">
                <Button size="large" @click="cancel('trustAdvisorWarningForm')">{{ $t('alarms.common.cancel') }}</Button>
                <Button type="primary" size="large" @click="ok('trustAdvisorWarningForm')" :loading="addloading" :disabled="isAddOrEdit">
                  {{!trustAdvisorWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import WechatWarning from '../../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
    import TableTrustAdvisorWarning from '../trustAdvisor_monitor/TableTrustAdvisorWarning.vue'

    var tableTrustAdvisorWarning = TableTrustAdvisorWarning;
    var tableTrustAdvisorWarningVue = {}
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.trustAdvisorWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error(this.$t('monitor.alarmRule.ruleNameRepeated')));
                    }
                })
            };
            return {
                getAreaType: "",
                monitorModule:10,
                addloading:false,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                  label: this.$t('alarms.common.alertContact'),
                    value: 'contact',
                    type: 0
                },
                {
                  label: this.$t('alarms.common.alertContactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                isShowField: '', //是否显示符号、阈值和单位
                singleBackupRegion:false,
                singleTrustedAdvisorItems:false,
                alarmDelayList:[],
                monitorPeriodList:[],
                isEdit: false,
                isEditRuleName: false,
                showRuleName: false,
                isShowEmail: false,
                isShowWeChat: false,
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                backupRegionList: [],
                trustedAdvisorItemsList:[],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                unit: '',
                trustAdvisorWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    backupRegion: [],
                    trustedAdvisorItems:[],
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds:[],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: this.$t('monitor.alarmRule.accountRequired'), trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: this.$t('monitor.alarmRule.alarmDelayRequired'), trigger: 'change', type: 'number'}
                    ],
                  monitorPeriod: [
                    {required: true, message: this.$t('monitor.alarmRule.monitorPeriodRequired'), trigger: 'change', type: 'number'}
                  ],
                    backupRegion: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.regionRequired'), trigger: 'change'}
                    ],
                    ruleName: [
                        {required: true, message: this.$t('monitor.alarmRule.ruleNameRequired'), trigger: 'blur'},
                        {type: 'string', message: this.$t('monitor.alarmRule.ruleNamePattern'), pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.notificationObjectRequired'), trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: this.$t('monitor.alarmRule.noticeTypeRequired'), trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: this.$t('monitor.alarmRule.monitorIndexRequired'), trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: this.$t('monitor.alarmRule.cycleRequired'), trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: this.$t('monitor.alarmRule.continousCycleRequired'), trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: this.$t('monitor.alarmRule.statisticsValueRequired'), trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: this.$t('monitor.alarmRule.relationshipSignRequired'), trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: this.$t('monitor.alarmRule.thresholdRequired')}
                    ],
                    contactType: [
                        {required: true, message: this.$t('monitor.alarmRule.contactTypeRequired'), trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: this.$t('monitor.alarmRule.contactGroupRequired'), trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.enterpriseWechatRobotRequired'), trigger: 'change'}
                    ]
                }
            }
        },

        beforeCreate: function () {
            tableTrustAdvisorWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            init: function (id) {
                this.trustAdvisorWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableTrustAdvisorWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['trustAdvisorWarningForm'].resetFields();
                    // 编辑
                    if (this.trustAdvisorWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.$api.alertRule.selectAlertRule("id", this.trustAdvisorWarningForm.id)
                            .then(res => {
                                //延时
                                this.trustAdvisorWarningForm.alarmDelay = res.data.delay;
                              //监控时段
                              this.trustAdvisorWarningForm.monitorPeriod = res.data.monitorPeriod;
                                // 账户
                                /******************************************************/
                                this.trustAdvisorWarningForm.account = res.data.accountId;
                                // 存储区域
                                tableTrustAdvisorWarningVue.$api.account.queryAccountRegions("accountId", this.trustAdvisorWarningForm.account)
                                .then(res => {
                                    this.backupRegionList = res.data;
                                });

                              tableTrustAdvisorWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                                "monitorModule":this.monitorModule,
                                "accountId":this.trustAdvisorWarningForm.account
                              })
                                .then(res => {
                                  this.notificationObjectList = res.data.contactList;
                                });

                                setTimeout(() => {
                                    this.trustAdvisorWarningForm.backupRegion = res.data.regions;
                                }, 1000)

                                // 规则名称
                                this.trustAdvisorWarningForm.ruleName = res.data.alertRuleName;

                                // 监控指标
                                /******************************************************/
                                // 查询监控指标
                                tableTrustAdvisorWarningVue.$api.alertRule.searchMonitorIndex({
                                    "monitorModule":this.monitorModule,
                                    "accountId":this.trustAdvisorWarningForm.account
                                })
                                .then(res => {
                                    this.monitorIndexList = res.data;
                                })
                                this.trustAdvisorWarningForm.monitorIndex = res.data.monitorIndex;
                                // 如果监控指标为TrustAdvisor时 不显示符号、阈值和单位
                                if (this.trustAdvisorWarningForm.monitorIndex == 55||this.trustAdvisorWarningForm.monitorIndex == 1590 ) {
                                    this.isShowField = 1;
                                } else {
                                    this.isShowField = 2;
                                }

                                // 周期
                                this.trustAdvisorWarningForm.cycle = res.data.cycle;
                                // 连续周期
                                this.trustAdvisorWarningForm.continousCycle = res.data.continousCycle;
                                // 统计数值
                                this.trustAdvisorWarningForm.statisticsValue = res.data.statisticsValue;
                                // 符号
                                this.trustAdvisorWarningForm.relationshipSign = res.data.relationshipSign;
                                // 阈值
                                this.trustAdvisorWarningForm.thresholdValue = res.data.thresholdValue;
                                // 检查项
                                this.trustAdvisorWarningForm.trustedAdvisorItems = res.data.trustedAdvisorItems;
                                // 单位
                                this.trustAdvisorWarningForm.unit = res.data.unit;
                                this.units = res.data.unitId;
                                // 企业微信机器人URL
                                this.trustAdvisorWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                                // 联系方式
                                this.trustAdvisorWarningForm.contactType = res.data.contactType;
                                if(res.data.contactType==0){
                                    // 通知对象
                                    this.trustAdvisorWarningForm.notificationObject = res.data.contactIDs;
                                    for(var i=0;i<this.trustAdvisorWarningForm.notificationObject.length;i++){
                                        for(var j=0;j<this.notificationObjectList.length;j++){
                                            if(this.trustAdvisorWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                                this.trustAdvisorWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                            }
                                        }
                                    }
                                }else if(res.data.contactType==1){
                                    // 联系人组
                                    this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.trustAdvisorWarningForm.account)
                                    .then(res => {
                                        this.contactGroupIdList = res.data;
                                    })
                                    setTimeout(() => {
                                        this.trustAdvisorWarningForm.contactGroupIds = res.data.contactGroupIds;
                                    }, 1000)
                                }

                                // 查询阈值
                                tableTrustAdvisorWarningVue.selectMonitorIndexDefault();

                                // 报警方式
                                this.trustAdvisorWarningForm.noticeType = res.data.noticeType;

                                for (var i = 0; i < this.trustAdvisorWarningForm.noticeType.length; i++){
                                    if (this.trustAdvisorWarningForm.noticeType[i] == '0') {
                                        this.isShowEmail = true;
                                        this.trustAdvisorWarningForm.emailModal = res.data.briefReportBodyMail;
                                        this.noticeType = this.trustAdvisorWarningForm.noticeType;
                                        tableTrustAdvisorWarningVue.selectTemplate();
                                    }
                                    if (this.trustAdvisorWarningForm.noticeType[i] == '1') {
                                        // this.isShowWeChat = true;
                                        this.trustAdvisorWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                        this.checkLeastOnePersonBoundWeChat();
                                        this.noticeType = this.trustAdvisorWarningForm.noticeType;
                                        tableTrustAdvisorWarningVue.selectTemplate();
                                    }else if(this.trustAdvisorWarningForm.noticeType[i]!='1'){
                                      this.wechatWarningVisible=false;
                                      this.isAddOrEdit=false;
                                  }
                                }
                            })
                    } else {
                        this.isEdit = false;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.trustAdvisorWarningForm.cycle = '';
                this.trustAdvisorWarningForm.continousCycle = '';
                this.trustAdvisorWarningForm.statisticsValue = '';
                this.trustAdvisorWarningForm.relationshipSign = '';
                this.trustAdvisorWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                // 如果监控指标为TrustAdvisor时 不显示符号、阈值和单位
                if (this.trustAdvisorWarningForm.monitorIndex == 55 ||this.trustAdvisorWarningForm.monitorIndex == 1590) {
                    this.isShowField = 1;
                } else {
                    this.isShowField = 2;
                }
                tableTrustAdvisorWarningVue.selectMonitorIndexDefault();
                this.unit = this.trustAdvisorWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.trustAdvisorWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableTrustAdvisorWarningVue.selectTemplate();
                tableTrustAdvisorWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                tableTrustAdvisorWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.trustAdvisorWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.trustAdvisorWarningForm.cycle,
                    "continousCycle": this.trustAdvisorWarningForm.continousCycle,
                    "statisticsValue": this.trustAdvisorWarningForm.statisticsValue,
                    "relationshipSign": this.trustAdvisorWarningForm.relationshipSign
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableTrustAdvisorWarningVue.isNotEmpty(this.trustAdvisorWarningForm.cycle) && tableTrustAdvisorWarningVue.isNotEmpty(this.trustAdvisorWarningForm.continousCycle) && tableTrustAdvisorWarningVue.isNotEmpty(this.trustAdvisorWarningForm.statisticsValue) && tableTrustAdvisorWarningVue.isNotEmpty(this.trustAdvisorWarningForm.relationshipSign) && this.trustAdvisorWarningForm.id == 0) {
                        this.trustAdvisorWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }

                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
              let t;
              this.accountList.forEach(element => {
                if (this.trustAdvisorWarningForm.account == element.id) {
                  t = element.areaType;
                }
              });
              tableTrustAdvisorWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.trustAdvisorWarningForm.monitorIndex,
                    "relationshipSign": this.trustAdvisorWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType": this.trustAdvisorWarningForm.noticeType
                })
                .then(res => {
                    this.trustAdvisorWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.trustAdvisorWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function () {
                this.isShowEmail = false;
                this.isShowWeChat = false;
                for(var i=0;i<this.trustAdvisorWarningForm.noticeType.length;i++) {
                    if (this.trustAdvisorWarningForm.noticeType[i] == '0') {
                        this.isShowEmail = true;
                        this.noticeType = this.trustAdvisorWarningForm.noticeType;
                        tableTrustAdvisorWarningVue.selectTemplate();
                    }
                    if (this.trustAdvisorWarningForm.noticeType[i] == '1') {
                        // this.isShowWeChat = true;
                        this.noticeType = this.trustAdvisorWarningForm.noticeType;
                        this.checkLeastOnePersonBoundWeChat();
                        tableTrustAdvisorWarningVue.selectTemplate();
                    }else if(this.trustAdvisorWarningForm.noticeType[i]!='1'){
                        this.wechatWarningVisible=false;
                        this.isAddOrEdit=false;
                    }
                }
            },
             // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.trustAdvisorWarningForm.noticeType.length;i++){
                  if(this.trustAdvisorWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.trustAdvisorWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.trustAdvisorWarningForm.contactType==0){
                          weChatDate.userIds=this.trustAdvisorWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.trustAdvisorWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.trustAdvisorWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.trustAdvisorWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.trustAdvisorWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.trustAdvisorWarningForm.userIdList=[];
              this.trustAdvisorWarningForm.notificationObject=val;
              for(var i=0;i<this.trustAdvisorWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.trustAdvisorWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.trustAdvisorWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            /**************************************  查询  **************************************/
            // 查询顾问检查项
            queryTrustedAdvisorItems: function () {
              tableTrustAdvisorWarningVue.$api.trustedAdvisor.listTrustedAdvisorCheckItems("areaType",this.getAreaType)
                .then(res => {
                  this.trustedAdvisorItemsList = res.data;
                })
            },
            // 查询监控指标
            searchMonitorIndex: function () {
                tableTrustAdvisorWarningVue.$api.alertRule.searchMonitorIndex({
                    "monitorModule":this.monitorModule,
                    "accountId":this.trustAdvisorWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
                tableTrustAdvisorWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.trustAdvisorWarningForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.trustAdvisorWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableTrustAdvisorWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                .then(res => {
                    this.alarmWayList = res.data;
                })
            },
             // 查询报警延迟
            getAlarmDelay: function () {
                tableTrustAdvisorWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                    this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableTrustAdvisorWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableTrustAdvisorWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableTrustAdvisorWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableTrustAdvisorWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableTrustAdvisorWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function () {
                // 清空表格
              this.$api.account.selectAccountByCloudPlatform("type", 0)
                .then(res => {
                    this.accountList = res.data;
                    for (var i = 0; i < this.accountList.length; i++) {
                        this.accountList[i].name = this.accountList[i].name;
                    }
                })
                // 查询阈值
                tableTrustAdvisorWarningVue.selectMonitorIndexDefault();
                // 查询方式
                tableTrustAdvisorWarningVue.alarmWay();
                // 查询报警延时
                tableTrustAdvisorWarningVue.getAlarmDelay();
                //监控时段
                tableTrustAdvisorWarningVue.searchMonitorPeriod();
                // 查询顾问检查项
                // tableTrustAdvisorWarningVue.queryTrustedAdvisorItems();
                // 监控模块查询关联的机器人列表
                tableTrustAdvisorWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableTrustAdvisorWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                    "monitorModule":this.monitorModule
                })
                .then(res => {
                    this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            // 选择账户
          changeAccount: function(row) {
            this.getAreaType = row.areaType;
            if (this.trustAdvisorWarningForm.account == "" || this.trustAdvisorWarningForm.account == null) {
                    return;
                }
                this.trustAdvisorWarningForm.backupRegion = [];
                // 查询顾问检查项
                tableTrustAdvisorWarningVue.queryTrustedAdvisorItems();
                // 查询监控指标
                tableTrustAdvisorWarningVue.searchMonitorIndex();
                // 清空表格
                tableTrustAdvisorWarningVue.$api.account.queryAccountRegions("accountId", this.trustAdvisorWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
                tableTrustAdvisorWarningVue.queryContacts();
                // 查询联系人组
                tableTrustAdvisorWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.trustAdvisorWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.trustAdvisorWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.trustAdvisorWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
            },
            /***********事件检查**************************/
            selectTrustedAdvisorItems(){
              this.trustAdvisorWarningForm.trustedAdvisorItems = []
              if (this.singleTrustedAdvisorItems) {
                this.trustedAdvisorItemsList.map((item) => {
                  this.trustAdvisorWarningForm.trustedAdvisorItems.push(item.name)
                })
              } else {
                this.trustAdvisorWarningForm.trustedAdvisorItems = []
              }
            },
            // 切换顾问检查项
            changeTrustedAdvisorItems: function (val) {
              if (val.length === this.trustedAdvisorItemsList.length&&val.length!=0) {
                this.singleTrustedAdvisorItems = true
              } else {
                this.singleTrustedAdvisorItems = false
              }
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                      let t;
                      this.accountList.forEach(element => {
                        if (this.trustAdvisorWarningForm.account == element.id) {
                          t = element.areaType;
                        }
                      });
                      var alertList = {
                            "alertRuleName": this.trustAdvisorWarningForm.ruleName,
                            "monitorIndex": this.trustAdvisorWarningForm.monitorIndex,
                            "cycle": this.trustAdvisorWarningForm.cycle,
                            "continousCycle": this.trustAdvisorWarningForm.continousCycle,
                            "statisticsValue": this.trustAdvisorWarningForm.statisticsValue,
                            "relationshipSign": this.trustAdvisorWarningForm.relationshipSign,
                            "accountId": this.trustAdvisorWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.trustAdvisorWarningForm.noticeType,
                            "unit": this.units,
                            "delay":this.trustAdvisorWarningForm.alarmDelay,
                            "monitorPeriod":this.trustAdvisorWarningForm.monitorPeriod,
                            "thresholdValue":this.trustAdvisorWarningForm.thresholdValue,
                            "regions":this.trustAdvisorWarningForm.backupRegion,
                            "contactType":this.trustAdvisorWarningForm.contactType,
                            "trustedAdvisorItems":this.trustAdvisorWarningForm.trustedAdvisorItems,
                            "enterpriseWechatRobotIds":this.trustAdvisorWarningForm.enterpriseWechatRobotIds
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.trustAdvisorWarningForm.contactType == 0){
                            alertList.contactIDs = this.trustAdvisorWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.trustAdvisorWarningForm.contactType == 1){
                          alertList.contactGroupIds = this.trustAdvisorWarningForm.contactGroupIds;
                        }

                        if (this.trustAdvisorWarningForm.id > 0) {
                            alertList.id = this.trustAdvisorWarningForm.id;
                            // 编辑告警
                             this.addloading=true;
                            tableTrustAdvisorWarningVue.$api.alertRule.updateAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.trustAdvisorWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success(this.$t('common.editSuccess'));
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                        this.trustAdvisorWarningForm.trustedAdvisorItems = this.data.trustedAdvisorItems;
                                    }, 1000);
                                })
                        } else {
                            // 添加告警
                            this.addloading=true;
                            tableTrustAdvisorWarningVue.$api.alertRule.createAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.trustAdvisorWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success(this.$t('common.addSuccess'));
                                        this.monitorIndexList=[];
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        }
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.trustAdvisorWarningForm.id > 0) {
                            this.$Message.error(this.$t('common.editFail'));
                        } else {
                            this.$Message.error(this.$t('common.addFail'));
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.trustAdvisorWarningForm.notificationObject = [];
                this.monitorIndexList=[];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                this.modal = false;
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/trustAdvisor/trustAdvisor_monitor/AddOrUpdateTrustAdvisorWarning.vue